import {
  type Filters,
  FilterSelect,
  Mtds,
  RequisitionStatus,
  StatusFilter,
  useGetSubstancesQuery,
  XIcon
} from 'prove-common'
import { useState } from 'react'

type RequisitionFilterTagsProps = {
  filters: Filters<RequisitionStatus>
  setFilters: React.Dispatch<React.SetStateAction<Filters<RequisitionStatus>>>
  isFiltering: boolean
}

export const RequisitionFilterTags = ({
  filters,
  setFilters,
  isFiltering
}: RequisitionFilterTagsProps) => {
  const [currentDialog, setCurrentDialog] = useState<string | undefined>()
  const {
    data: substances,
    isPending: isPendingSubstancesQuery,
    isError: isErrorSubstances
  } = useGetSubstancesQuery(currentDialog === 'substances')
  const substanceOptions =
    substances?.map((substance) => ({
      id: substance.id.toString(),
      name: substance.name
    })) ?? []
  const statusOptions: { id: RequisitionStatus; name: string }[] = [
    {
      id: RequisitionStatus.no_reports_uploaded,
      name: 'No reports uploaded'
    },
    {
      id: RequisitionStatus.reports_uploaded,
      name: 'Report(s) uploaded'
    },
    {
      id: RequisitionStatus.completed,
      name: 'Analysis reported complete'
    },
    {
      id: RequisitionStatus.compromised,
      name: 'Dismissed'
    }
  ]
  return (
    <Mtds.Flex>
      <Mtds.Input
        type='search'
        data-cy='search-input'
        value={filters.searchText}
        size={21}
        aria-label='Search by sample ID'
        placeholder='Search by sample ID'
        onKeyDown={({ key }) =>
          key === 'Enter' &&
          setFilters({ ...filters, sampleId: filters.searchText })
        }
        onChange={({ target: { value } }) => {
          setFilters({
            ...filters,
            searchText: value.length > 0 ? value : undefined
          })
        }}
      />
      <FilterSelect
        name='Substances'
        placeholder='Search'
        searchAriaLabel='Search'
        errorMessage='Something went wrong.'
        options={substanceOptions}
        selectedIds={filters.substanceIds ?? []}
        setSelectedIds={(ids) => setFilters({ ...filters, substanceIds: ids })}
        onOpenChange={(isOpen) =>
          setCurrentDialog(isOpen ? 'substances' : undefined)
        }
        isLoading={isPendingSubstancesQuery}
        isError={isErrorSubstances}
        data-cy='filter-substance'
      />
      <FilterSelect
        name='Status'
        placeholder={'Search'}
        searchAriaLabel='Search'
        errorMessage='Something went wrong.'
        options={statusOptions}
        selectedIds={filters.status ?? []}
        setSelectedIds={(ids) =>
          setFilters({
            ...filters,
            status: ids as StatusFilter<RequisitionStatus>
          })
        }
        selectionMode='multiple'
      />
      {isFiltering && (
        <Mtds.Button
          onClick={() =>
            setFilters({
              productIds: [],
              sampntTypeIds: [],
              substanceIds: [],
              planIds: [],
              matrixIds: [],
              status: []
            })
          }
        >
          <XIcon />
          Remove filters
        </Mtds.Button>
      )}
    </Mtds.Flex>
  )
}
